import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["time"]
  static values = {
    format: { type: String, default: "24" }, // 24 or 12 hour format
    showSeconds: { type: Boolean, default: false }
  }

  connect() {
    this.updateTime()
    this.startTimer()
  }

  disconnect() {
    this.stopTimer()
  }

  startTimer() {
    this.timer = setInterval(() => { this.updateTime() }, 1000)
  }

  stopTimer() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  updateTime() {
    const now = new Date()
    let timeString

    // 24-hour format
    const hours = now.getHours().toString().padStart(2, '0')
    const minutes = now.getMinutes().toString().padStart(2, '0')
    const seconds = now.getSeconds().toString().padStart(2, '0')
    // timeString = `${hours}:${minutes}<span class="seconds">${seconds}</span>`
    timeString = `${hours}:${minutes}`

    this.timeTarget.innerHTML = timeString
  }
}
